// src/utils/geo.js
export function getBrowserPosition({
  timeout = 20000,
  highAccuracy = false,
  maximumAge = 60000,
} = {}) {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocalización no soportada por el navegador"));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { latitude, longitude, accuracy } = pos.coords || {};
        resolve({ lat: latitude, lng: longitude, accuracy: accuracy ?? null });
      },
      (err) => reject(err),
      { enableHighAccuracy: highAccuracy, timeout, maximumAge }
    );
  });
}

export function qualityFromAccuracy(accuracy) {
  if (accuracy == null || Number.isNaN(accuracy)) return "low";
  if (accuracy <= 25) return "high";
  if (accuracy <= 100) return "medium";
  return "low";
}
